"use client";
import * as React from "react";
import { List, ListItem, ListItemText, Typography } from "@mui/material";

interface Props {
  events: Array<{ seq: number; kind: string; data: any; ts: string }>;
}

export function SubagentEventList({ events }: Props) {
  if (events.length === 0) {
    return <Typography variant="caption" color="text.secondary">No events yet.</Typography>;
  }
  return (
    <List dense sx={{ maxHeight: 240, overflow: "auto", mt: 1 }}>
      {events.slice(-200).map((e) => (
        <ListItem key={e.seq} disableGutters>
          <ListItemText
            primary={<><strong>{e.kind}</strong> {summarize(e.data)}</>}
            secondary={new Date(e.ts).toLocaleTimeString()}
            slotProps={{
              primary: { variant: "body2" } as any,
              secondary: { variant: "caption" } as any,
            }}
          />
        </ListItem>
      ))}
    </List>
  );
}

function summarize(data: any): string {
  if (data?.tool) return `${data.tool}`;
  if (data?.text) return data.text.slice(0, 120);
  if (data?.reason) return `(${data.reason})`;
  return "";
}
